import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// Shown while a route's chunk loads after an in-app navigation. Never on first
// load: src/index.js loads the landing route before rendering (utils/lazyPage).
export const PageFallback = () => (
  <Box
    // Lets react-snap's first-render check (utils/firstRender) recognise it.
    data-page-fallback="true"
    sx={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <CircularProgress size={48} />
  </Box>
);

export default PageFallback;
